import { GetProjectResponse } from "api/generatedApi";
import { Role, useRoleRestriction } from "./use-role-restriction";

export const useRateRestrictions = (project: GetProjectResponse) => {
  const { hasRole } = useRoleRestriction(project);

  const canEditBaseRateAndSupplements = (): boolean => {
    if (hasRole([Role.Owner, Role.AssistantOwner, Role.Manager])) {
      return true;
    }
    return false;
  };

  return { canEditBaseRateAndSupplements };
};
